/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

const barHeight = $('.shopify-section--announcement-bar').outerHeight();
document.documentElement.style.setProperty('--announcement-height', `${barHeight}px`);

$(document).ready(function() {

  $(".bestselling-section-items_list").slick({
        dots: true,
        arrows: false,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
    });

    $(".featured-text-slider").slick({
        dots: false,
        arrows: true,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        touchThreshold: 100,
        responsive: [{
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            }
        }]
    });

    // $(".rel-trans-list").slick({
    //   dots: true,
    //   arrows: false,
    //   infinite: true,
    //   centerMode: true,
    //   centerPadding:'50px',
    //   slidesToShow: 2,
    //   slidesToScroll: 2,
    //   touchThreshold:100,
    //   responsive: [
    //   {
    //     breakpoint: 999,
    //     settings: {
    //       slidesToShow: 2,
    //       slidesToScroll: 2,
    //     }
    //   },
    //   {
    //     breakpoint: 740,
    //     settings: {
    //       centerPadding:'35px'
    //     }
    //   }
    // ]
    // });

    $(".featured_card_carousel_iner").slick({
        dots: true,
        arrows: false,
        infinite: true,
        centerMode: true,
        centerPadding: '350px',
        slidesToShow: 2,
        slidesToScroll: 1,
        touchThreshold: 100,
        responsive: [{
                breakpoint: 1200,
                settings: {
                    centerPadding: '200px'
                }
            },
            {
                breakpoint: 999,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerPadding: '100px'
                }
            },
            {
                breakpoint: 740,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerPadding: '35px'
                }
            }
        ]
    });

    $(".ab-wrap").slick({
        dots: true,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [{
            breakpoint: 740,
            settings: {
                slidesToShow: 1,
                adaptiveHeight: true,
            }
        }]
    });

    $(".testi-secondary-iner").slick({
        dots: true,
        arrows: false,
        infinite: true,
        centerMode: true,
        centerPadding: '350px',
        slidesToShow: 2,
        slidesToScroll: 1,
        touchThreshold: 100,
        responsive: [{
                breakpoint: 1200,
                settings: {
                    centerPadding: '200px'
                }
            },
            {
                breakpoint: 999,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerPadding: '100px'
                }
            },
            {
                breakpoint: 740,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerPadding: '0px'
                }
            }
        ]
    });

    $('body').on('click', '.pdp_collapsible_btn:not(.pdp_collapsible_btn-ing)', function() {
        $(this).closest('.section__color-wrapper').toggleClass('bg_clrr');
        $(this).toggleClass('active');
        $(this).siblings('.custom_ingredients_inr_list_collapsible').toggleClass('active').slideToggle();
    })

    $('body').on('click', '.ingredients-section-toggle-btn', function() {
      $(this).parents('.ingredients-section-wrapper').toggleClass('active');
      $(this).next('.ingredients-section_list').slideToggle();
      if($(this).parents('.ingredients-section-wrapper').attr('id')) {
        // console.log('kdfd');
        var mainId = $(this).parents('.ingredients-section-wrapper').attr('id');
        $('.ingredients-section-wrapper').each(function( index,section ) {
          // console.log($(this).attr('sub-id'));
          var subId = $(this).attr('sub-id');
          // console.log('mainId',mainId, 'subId',subId);  
          if( mainId == subId ) {
            $(this).toggleClass('active');
            $(this).find('.ingredients-section_list').slideToggle();
          }
        });
      }
    })

  
  $('body').on('click','.product-des-toggle-btn', function() {
    $(this).toggleClass('active');
    $(this).parents('.product-des-wrapper').toggleClass('active');
    $(this).next('.ingredients-section_list').slideToggle();
  })
  

    $('body').on('click', '.pdp_collapsible_btn-ing', function() {
        $(this).closest('.section__color-wrapper').toggleClass('bg_clrr');
        $(this).toggleClass('active');
        $(this).next('.custom_ingredients_inr_list_collapsible').toggleClass('active').slideToggle();
        if($(this).parents('.custom-ingredients-wrp').hasClass('main-section')) {
          console.log('0000');
          $('.sub-section').find('.custom_ingredients_inr_list').toggle();
        }
    });

    $('body').on('click', '.sensitive-skin_header', function() {
        $(this).parents('.sensitive-skin').toggleClass('active');
        $(this).next('.sensitive-skin_main').toggle();
    });

    $('body').on('click', '.main-product-secondary-block .mpsb-item-atc-wrp .consultation-btn-atc', function() {
        var vid = $(this).attr('data-vid');
        $.ajax({
            type: 'POST',
            url: '/cart/update.js',
            data: 'updates[' + vid + ']=0',
            dataType: 'json',
            error: function(jqXHR, textStatus, errorThrown) {
                console.log('error');
            },
            success: function() {
                console.log('success');
            }
        });
       let d= document.querySelector('form[data-loop-product-id]');
      let pid=d.getAttribute('data-loop-product-id');
      console.log(pid)
      console.log(window?.loopProps[pid]?.sellingPlanId)
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
                id: vid,
                quantity: 1,
                selling_plan: window?.loopProps? window?.loopProps[pid]?.sellingPlanId: null
            },
            dataType: 'json',
            error: function(jqXHR, textStatus, errorThrown) {
                console.log('error');
            }
        }).done(function(data) {
            window.location.href = '/checkout';
        });
    });
    $('.content-read_more-less').click(function(e) {
        e.preventDefault();
        $('.content-box_content').toggle();
    });

  function scrollToSection(event) {
    var width = $(window).outerWidth();
    event.preventDefault();
    $(".product-form__buy-buttons a").removeClass("active");
    $(this).addClass("active");
    var $section = $($(this).attr("href"));
    if(width<=999){
       $("html, body").animate(
        {
          scrollTop: $section.offset().top - 240,      
        },
        500
      ); 
    } else {
      $("html, body").animate(
        {
          scrollTop: $section.offset().top - 0,      
        },
        500
      );
    }   
  }
  $(".ptb_link").on("click", scrollToSection);
  
});
$(window).scroll(function() {
    var banner_height = $('.banner-sticy-button').prev('.index-banner').height();
    if ($(this).scrollTop() > banner_height) {
        $('.banner-sticy-button').addClass('show');
    } else {
        $('.banner-sticy-button').removeClass('show');
    }

    if($('.main-product-secondary').length > 0){
      var pdp_main = $('.main-product-secondary').height() - 70;
      if ($(this).scrollTop() > pdp_main) {
          $('.mpsb-item-atc-wrp.sticky').addClass('active');
      } else {
          $('.mpsb-item-atc-wrp.sticky').removeClass('active');
      }
    }

    if($('.shopify-section--main-product').length > 0){
      var default_pdp_main = $('.shopify-section--main-product').height() - 70;
      if ($(this).scrollTop() > default_pdp_main) {
          $('.mpsb-item-atc-wrp.sticky').addClass('active');
      } else {
          $('.mpsb-item-atc-wrp.sticky').removeClass('active');
      }
    }

    if($('.main-product-secondary').length > 0){
      var pdp_main = $('.main-product-secondary').height() - 70;
      if ($(this).scrollTop() > pdp_main) {
          $('.product-sticky-info').addClass('active');
      } else {
          $('.product-sticky-info').removeClass('active');
      }
    }

    $('.see-all_reviews').on('click', function(e) {
        var target = this.hash,
            $target = $(target);

        $('html, body').stop().animate({
            'scrollTop': $target.offset().top - 170
        }, 900, 'swing', function() {
            window.location.hash = target;
        });
    });
});

// APP LOOP WIDGET CUSTOM CODE V1
$('body').on('change', 'input[name="loop_purchase_option"]:not(.recently_added)', function () {
  $(`.subscription-dropdown`).addClass('recently_added');
  $(`.subscription-dropdown option`).removeAttr("selected");
  // $(`.subscription-dropdown option[value=${$(this).attr('data-name')}]`).attr('selected', 'selected');

  $(`.subscription-dropdown`).val($(this).attr('data-name')).change();

  $("#sticky-product-current_variant-price").text('000000')
  if($(this).attr('data-name') == 'Subscribe'){
    $("#sticky-product-current_variant-price").text($('#sticky-product-current_variant-price').attr('subscribe_price'))
  }else{
    $("#sticky-product-current_variant-price").text($('#sticky-product-current_variant-price').attr('one_time_price'))
  }
  setTimeout(function(){
    $(`.subscription-dropdown`).removeClass('recently_added');  
  },500);
});
$('body').on('change', '.subscription-dropdown:not(.recently_added)', function () {
  var value = $(this).val();
  $(`input[name="loop_purchase_option"][data-name="${value}"]`).addClass('recently_added');
  $(`input[name="loop_purchase_option"][data-name="${value}"]`).trigger('click');
  if(value == 'Subscribe'){
    $("#sticky-product-current_variant-price").text($('#sticky-product-current_variant-price').attr('subscribe_price'))
  }else{
    $("#sticky-product-current_variant-price").text($('#sticky-product-current_variant-price').attr('one_time_price'))
  }
  setTimeout(function(){
    $(`input[name="loop_purchase_option"][data-name="${value}"]`).removeClass('recently_added');  
  },500);
});
$('body').on('click', '.product-form__sticky-add-button', function () {
  $('#AddToCart').trigger('click');
});


// APP LOOP WIDGET CUSTOM CODE V2
$('body').on('click', '.product-sticky-button', function () {
  var _this = $(this);
  $('#AddToCart').trigger('click');
  _this.attr("disabled","disabled");
  _this.attr("aria-busy","true");
  setTimeout(function(){
    _this.removeAttr("disabled");
    _this.removeAttr("aria-busy");
  },5000);
});
// $('body').on('click', '.loop-widget-purchase-option-onetime:not(.recently_added)', function () {
//   $(`.subscription-dropdown`).addClass('recently_added');
//   $(`.subscription-dropdown option`).removeAttr("selected");
//   $(`.subscription-dropdown`).val('one-time').change();
//   setTimeout(function(){
//     $(`.subscription-dropdown`).removeClass('recently_added');  
//   },500);
//   console.log('clicked')
// });
 document.addEventListener('variant:changed', function(event) {
  let variant = event.detail.variant; // Gives you access to the whole variant details
  let form = event.target;
  $(`.product-sticky-form .subscription-dropdown`).val('subscribe').change();  
});
$('body').on('click', 'div[data-loop-widget-purchase-option]:not(.recently_added)', function () {
  $(`.subscription-dropdown`).addClass('recently_added');
  $(`.subscription-dropdown option`).removeAttr("selected");
  console.log($(this).find('.loop-widget-purchase-option-price').text());
  if($(this).hasClass("loop-widget-purchase-option-onetime")){
    $(`.subscription-dropdown`).val('one_time').change();
    console.log('one');
    $('.subscription-price').hide();
    $('.onetime-price').show();
  }else{
    $(`.subscription-dropdown`).val('subscribe').change();  
    $('.subscription-price').show();
    $('.onetime-price').hide();
    console.log('subscribe');
  }
  setTimeout(function(){
    $(`.subscription-dropdown`).removeClass('recently_added');  
  },500);
});

$('body').on('change', '.subscription-dropdown:not(.recently_added)', function () {
  var value = $(this).val();
  if(value == 'one_time'){
    $(`div[data-loop-widget-purchase-option].loop-widget-purchase-option-onetime`).addClass('recently_added');
    $(`div[data-loop-widget-purchase-option].loop-widget-purchase-option-onetime`).trigger('click');   
    
    $('.subscription-price').hide();
    $('.onetime-price').show();
  }else{
    $(`div[data-loop-widget-purchase-option]:not(.loop-widget-purchase-option-onetime)`).addClass('recently_added');
    $(`div[data-loop-widget-purchase-option]:not(.loop-widget-purchase-option-onetime)`).trigger('click');    

    $('.subscription-price').show();
    $('.onetime-price').hide();
  }
  setTimeout(function(){
    $(`div[data-loop-widget-purchase-option]`).removeClass('recently_added');  
  },500);
});


var pitta = 0;
var vata = 0;
var kapha = 0;
var ingredient_type = '';

var pitta_options = '';
var vata_options = '';
var kapha_options = '';

if ($("body").attr("class").match(/\buae\b/)) {
  var pitta_options = ["8dhoOGb", "xoh0NGP", "g5hqyYb", "d9hzql8", "8dhoOGq"];
  var vata_options = ["7mhaln0", "zWhXg2A", "oZhA7V3", "mkhZMXW", "9yheG5M"];
  var kapha_options = ["5nhEZlO", "RbhzXox", "nlhbdE2", "yJhZmQ7", "7mhaln5"];
}else{
  var pitta_options = ["amhVdGo", "NGhmx8Q", "jPhQjRA", "bdhMDGq", "OJhVNw4"];
  var vata_options = ["36hJEyj", "Yrh0M4d", "Qwh9ewZ", "wjh7a5E", "4EhGe9d"];
  var kapha_options = ["e7hG8Vg", "MjhgNpR", "Gahol7Y", "qahoJmQ", "V4hVPR2"];
}

var quiz_data = JSON.parse(window.localStorage.getItem("Quiz"));

if ($("body").attr("class").includes("uae")) {
  console.log("True - 'uae' is in the body class");
  var quiz_data = JSON.parse(window.localStorage.getItem("UAE Quiz"));
} else {
  console.log("False - 'uae' is NOT in the body class");
  var quiz_data = JSON.parse(window.localStorage.getItem("Quiz"));
}

if (quiz_data != null) {
    var hair_oil = [quiz_data.quiz.attributes.slides.data[5].attributes.values[0], quiz_data.quiz.attributes.slides.data[6].attributes.values[0], quiz_data.quiz.attributes.slides.data[7].attributes.values[0], quiz_data.quiz.attributes.slides.data[8].attributes.values[0], quiz_data.quiz.attributes.slides.data[9].attributes.values[0]];
    if(quiz_data.quiz.attributes.slides.data[0].attributes.values[0]){
      $('#customer_name').html(`Hi ${quiz_data.quiz.attributes.slides.data[0].attributes.values[0]}`);
    }
    $.map(kapha_options, function(val, i) {
        if (hair_oil.includes(val)) {
            kapha = kapha + 1;
        }
    });
    $.map(vata_options, function(val, i) {
        if (hair_oil.includes(val)) {
            vata = vata + 1;
        }
    });
    $.map(pitta_options, function(val, i) {
        if (hair_oil.includes(val)) {
            pitta = pitta + 1;
        }
    });
    if (pitta >= 3) {
        $(".quiz-result-custom-ingredients").addClass('pitta');
        ingredient_type += 'pitta ';
        $('#ingredient-type').html(ingredient_type);
    } else if (vata >= 3) {
        $(".quiz-result-custom-ingredients").addClass('vata');
        ingredient_type += 'vata ';
        $('#ingredient-type').html(ingredient_type);
    } else if (kapha >= 3) {
        $(".quiz-result-custom-ingredients").addClass('kapha');
        ingredient_type += 'kapha ';
        $('#ingredient-type').html(ingredient_type);
    } else {
        if (pitta == 2 && vata == 2) {
            $(".quiz-result-custom-ingredients").addClass('pitta vata');
            ingredient_type += 'pitta & vata';
            $('#ingredient-type').html(ingredient_type);
        }
        if (pitta == 2 && kapha == 2) {
            $(".quiz-result-custom-ingredients").addClass('pitta kapha');
            ingredient_type += 'pitta & kapha';
            $('#ingredient-type').html(ingredient_type);
        }
        if (vata == 2 && kapha == 2) {
            $(".quiz-result-custom-ingredients").addClass('vata kapha');
            ingredient_type += 'vata & kapha ';
            $('#ingredient-type').html(ingredient_type);
        }
    }
    console.log('quiz_data', quiz_data, 'quiz_data q', hair_oil);
    console.log("op", pitta, vata, kapha);
    console.log('quiz_data.quiz.attributes.slides.data[3].attributes.values[0]',quiz_data.quiz.attributes.slides.data[3].attributes.values[0]);
    $('.ab-wrap').addClass(quiz_data.quiz.attributes.slides.data[3].attributes.values[0])
    $('.after-before_wrap').addClass(quiz_data.quiz.attributes.slides.data[3].attributes.values[0])
}